"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "46fe964f-56f6-4c73-9e6d-dad193ad8f73",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "broadband-mid"), /*#__PURE__*/React.createElement("circle", {
    id: "e99e0fb4-3439-499f-81de-186ca9943bb6",
    "data-name": "<Path>",
    cx: 96,
    cy: 144,
    r: 8,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "29831d72-f23d-4b7d-b716-0b313fa39325",
    "data-name": "<Path>",
    d: "M20,71.5a107.43,107.43,0,0,1,152,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "10d254af-9faf-4216-85b4-ce3d4bd26afd",
    "data-name": "<Path>",
    d: "M42,94.51a76.75,76.75,0,0,1,108.6,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "3e7227ea-899b-4d70-9512-7db590e820eb",
    "data-name": "<Path>",
    d: "M64.6,117.08a44.6,44.6,0,0,1,63.11,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_broadband;
exports.default = _default;